import type { FC } from 'react';
import React from 'react';
import type { CartDto } from '../../../../../../../generated-api';
import CartItem from './CartItem';
import { getUniqueOrderLineKey } from '../../../../../../utils/orderLineUtils';

interface Props {
  orderLines: CartDto['orderLines'];
}

const CartItems: FC<Props> = ({ orderLines }) => (
  <ul className="overflow-auto h-full">
    {orderLines.map((order) => (
      <CartItem key={`${getUniqueOrderLineKey(order)}`} orderLine={order} />
    ))}
  </ul>
);
export default CartItems;
